import Autocomplete from '../utils/autocomplete';
import SearchController from '../utils/main-search';
const search = () => {
  const minLength = 2;
  const autocompleteForms = document.querySelectorAll('.js-search-form');
  const searchHeader = document.querySelector('.o-page__header');
  const searchOpen = document.querySelectorAll('#open-header-search, #close-header-search, .c-header__actions-link--search');
  searchOpen.forEach(toggler => {
    toggler.addEventListener('click', () => {
      searchHeader.classList.toggle('u-search-visible');
    });
  });
  autocompleteForms.forEach($form => {
    new Autocomplete({
      selector: $form,
      minLength
    });
  });
  const applyTeaserTruncation = function () {
    let container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    container.querySelectorAll('.results-teaser').forEach($teaser => {
      const $content = $teaser.querySelector('.result-content');
      if (!$content || !$content.dataset.resultContentFull) return;
      const contentText = $content.textContent.replace(/&shy;|­/g, '').trim().replace(/\s+/g, ' ');
      const contentFullText = $content.dataset.resultContentFull.replace(/&shy;|­/g, '').trim().replace(/\s+/g, ' ');
      if (contentText === contentFullText) return;
      const lookupLength = 20;

      // Fix words cut immediately before [...] markers
      const textCurrent = $content.textContent.trim().replace(/\s+/g, ' ');
      const dotsRe = /(\S+)(\s*\[\.\.\.\])/g;
      let dotsMatch;
      while ((dotsMatch = dotsRe.exec(textCurrent)) !== null) {
        const candidate = dotsMatch[1];
        const pos = contentFullText.indexOf(candidate);
        if (pos < 0) continue;
        const nextChar = contentFullText[pos + candidate.length];
        if (nextChar && nextChar !== ' ') {
          const spaceAfter = contentFullText.indexOf(' ', pos + candidate.length);
          const fullWord = spaceAfter >= 0 ? contentFullText.slice(pos, spaceAfter) : contentFullText.slice(pos);
          const esc = candidate.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          $content.innerHTML = $content.innerHTML.replace(new RegExp(`${esc}(\\s*\\[\\.\\.\\.\\])`), `${fullWord}$1`);
        }
      }

      // Check start truncation
      const startChunk = contentText.slice(0, lookupLength);
      const startPos = contentFullText.indexOf(startChunk);
      if (startPos > 0) {
        const wordBoundary = contentFullText.lastIndexOf(' ', startPos - 1) + 1;
        const missingStart = contentFullText.slice(wordBoundary, startPos);
        $content.innerHTML = `[...] ${missingStart}${$content.innerHTML}`;
      }

      // Check end truncation
      const endChunk = contentText.slice(-lookupLength);
      const endChunkPos = contentFullText.lastIndexOf(endChunk);
      if (endChunkPos >= 0) {
        const snippetEndInFull = endChunkPos + endChunk.length;
        if (snippetEndInFull < contentFullText.length) {
          const spaceAfter = contentFullText.indexOf(' ', snippetEndInFull);
          const wordEnd = spaceAfter >= 0 ? spaceAfter : contentFullText.length;
          const missingEnd = contentFullText.slice(snippetEndInFull, wordEnd);
          $content.innerHTML += `${missingEnd} [...]`;
        }
      }
    });
  };
  new SearchController(window.solrSearchAjaxType, applyTeaserTruncation).init();
  applyTeaserTruncation();
};
export default search;